import { z } from "zod";
export const AIQuestionAnswerSchema = z.object({
    id: z.string(),
    question: z.string(),
    answer: z.string(),
    context: z.string(),
    timestamp: z.number(),
    isComplete: z.boolean().optional(),
    questionId: z.string().optional(),
});
export const PartialAIResponseSchema = z.object({
    id: z.string().nullable().optional(),
    question: z.string().nullable().optional(),
    answer: z.string().nullable().optional(),
    context: z.string().nullable().optional(),
    isComplete: z.boolean().nullable().optional(),
    questionId: z.string().nullable().optional(),
});
export const AILatencyMetricsSchema = z.object({
    clickTimestamp: z.number(),
    aiRequestTimestamp: z.number(),
    firstTokenTimestamp: z.number(),
    completionTimestamp: z.number(),
    totalDuration: z.number(),
    aiRequestDuration: z.number(),
    generationDuration: z.number(),
    model: z.string(),
    error: z.boolean().optional(),
    questionId: z.string().optional(),
});
export const KnowledgeMatchSchema = z.object({
    text: z.string(),
    fileName: z.string(),
    score: z.number(),
    chunkIndex: z.number().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const AIStreamingStatusSchema = z.enum([
    "started",
    "detecting_question",
    "searching_faqs",
    "found_faq",
    "searching_knowledge",
    "has_knowledge",
    "no_knowledge",
    "generating_answer",
    "streaming",
    "done",
]);
